<template>
    <auth-layout>
        <div class="container mt-5 mb-3 pt-5">
            <div class="row justify-content-center">
                <div class="col-md-10 col-xl-8">
                    <form class="card"
                          autocomplete="off"
                          autocapitalize="off"
                          @submit.prevent="submit()">
                        <div class="card-header">
                            <logo class="text-center" :show-name="true"/>
                        </div>
                        <div class="card-body">

                            <div class="row">
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <label for="first-name">First Name</label>
                                        <input type="text" id="first-name" class="form-control" placeholder="First Name" v-model="form.first_name">
                                        <error-line field="first_name"/>
                                    </div>
                                </div>

                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <label for="name">Last Name</label>
                                        <input type="text" id="name" class="form-control" placeholder="Last Name" v-model="form.last_name">
                                        <error-line field="last_name"/>
                                    </div>
                                </div>

                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <label for="email">Email</label>
                                        <input type="email"
                                               id="email"
                                               class="form-control"
                                               placeholder="example@domain.com"
                                               v-model="form.email">
                                        <error-line field="email"/>
                                    </div>
                                </div>

                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <label for="referred-by">Referred By (Optional)</label>
                                        <input class="form-control"
                                               type="text"
                                               v-model="form.referred_by"
                                               id="referred-by"
                                               placeholder="Give referrer name / code">
                                        <error-line field="referred_by"/>
                                    </div>
                                </div>
                            </div>


                            <div class="row">
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <label for="password">Password</label>
                                        <input type="password"
                                               id="password"
                                               class="form-control"
                                               placeholder="Secure Password"
                                               v-model="form.password">
                                        <error-line field="password"/>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <label for="password-confirmation">Confirm Password</label>
                                        <input type="password"
                                               id="password-confirmation"
                                               class="form-control"
                                               placeholder="Retype same password"
                                               v-model="form.password_confirmation">
                                    </div>
                                </div>
                            </div>


                            <div class="form-group">
                                <div class="row align-items-center">
                                    <div class="col-md-3 mt-0 mt-md-5 mb-3">
                                        <label for="number-of-students">Number of Students</label>
                                    </div>
                                    <div class="col-md-9 mt-5 mb-3">
                                        <div class="px-3">
                                            <slider v-model="form.number_of_students"
                                                    :format="(v) => v >= 100 ? '100+' : parseInt(v)"
                                                    :min="1"
                                                    :max="100"/>
                                        </div>
                                    </div>
                                </div>

<!--                                <div class="row">-->
<!--                                    <div class="col-lg-4">-->
<!--                                        <input type="number"-->
<!--                                               id="number-of-students"-->
<!--                                               class="form-control"-->
<!--                                               step="1"-->
<!--                                               min="1"-->
<!--                                               max="999"-->
<!--                                               placeholder="Give the number of students you want to manage"-->
<!--                                               v-model="form.number_of_students">-->
<!--                                    </div>-->
<!--                                    <div class="col-lg-4">-->
<!--                                        <input type="range"-->
<!--                                               id="number-of-students-range"-->
<!--                                               class="form-control"-->
<!--                                               step="1"-->
<!--                                               v-model="form.number_of_students">-->
<!--                                    </div>-->
<!--                                </div>-->
                                <error-line field="number_of_students"/>
                            </div>


                            <template v-if="referred_org">
                                Joining <strong>{{ referred_org.value.name }}</strong>
                                <span class="user-count font-weight-bold" v-if="referred_org.value.users_count">
                                    ({{ referred_org.value.users_count }} {{ referred_org.value.users_count > 1 ? 'users are' : 'user is' }} here)
                                </span>
                                <div>{{ referred_org.value.meta?.address }}</div>
                            </template>
                            <template v-else>
                                <div class="my-3 bg-light p-3 rounded">
                                    <div class="custom-control custom-checkbox custom-control-inline">
                                        <input type="radio"
                                               class="custom-control-input"
                                               name="create-organization"
                                               id="create-organization"
                                               v-model="form.has_organization"
                                               :value="true">
                                        <label class="custom-control-label"
                                               for="create-organization">I'm a teacher in an Organization</label>
                                    </div>
                                    <div class="custom-control custom-checkbox custom-control-inline">
                                        <input type="radio"
                                               class="custom-control-input"
                                               name="create-organization"
                                               id="create-non-organization"
                                               v-model="form.has_organization"
                                               :value="false">
                                        <label class="custom-control-label"
                                               for="create-non-organization">I'm a parent</label>
                                    </div>
                                </div>


                                <template v-if="form.has_organization && !form.create_organization">

                                    <div class="form-group">
                                        <label for="organization">Search for an organization or a place.</label>
                                        <input placeholder="Start typing to search..."
                                               v-model="search.query"
                                               id="organization"
                                               class="form-control"
                                               autocomplete="off"
                                               @keyup="debouncedPlaceSearch"/>
                                        <error-line field="organization.id"/>
                                    </div>


                                    <div v-if="search.results.length" class="results">
                                        <label class="mr-2">Below are the organizations that we're able to find.</label>
                                        <div class="custom-control custom-radio search-item" v-for="item in search.results" :key="item.id">
                                            <template v-if="item.type === 'org'">
                                                <input type="radio"
                                                       :id="`search-item-${item.id}`"
                                                       name="search-item"
                                                       v-model="search.selected"
                                                       :value="item.id"
                                                       class="custom-control-input">
                                                <label class="custom-control-label" :for="`search-item-${item.id}`">
                                                    <strong>{{ item.value.name }}</strong>
                                                    <strong v-if="item.id === referred_org?.id" class="text-feel"> (Referred)</strong>
                                                    <span class="user-count font-weight-bold" v-if="item.value.users_count">
                                                        ({{ item.value.users_count }} {{ item.value.users_count > 1 ? 'users are' : 'user is' }} here)
                                                    </span>
                                                    <div>{{ item.value.meta?.address }}</div>
                                                </label>
                                            </template>
                                            <template v-if="item.type === 'ac'">
                                                <input type="radio"
                                                       :id="`search-item-${item.id}`"
                                                       name="search-item"
                                                       v-model="search.selected"
                                                       :value="item.id"
                                                       class="custom-control-input">
                                                <label class="custom-control-label" :for="`search-item-${item.id}`">
                                                    <strong>{{ item.value?.structured_formatting?.main_text }}</strong>
                                                    <div>{{ item.value?.structured_formatting?.secondary_text }}</div>
                                                </label>
                                            </template>
                                        </div>
                                    </div>

                                    <p class="mt-3" v-if="search.query && !search.is_busy">
                                        Can't find your organization or place?
                                        <a @click.prevent.stop="createOrganization(true)"
                                           href="#">Create new organization</a>.
                                    </p>

                                </template>

                                <template v-if="form.has_organization && form.create_organization">

                                    <p class="mt-3">
                                        Want to give search a try again?
                                        <a @click.prevent.stop="createOrganization(false)"
                                           href="#">Search for an existing organization or a place</a>.
                                    </p>

                                    <div class="form-group">
                                        <label for="organization-name">Organization Name</label>
                                        <input class="form-control"
                                               type="text"
                                               id="organization-name"
                                               placeholder="Name of your organization or a place"
                                               v-model="form.organization.name">
                                        <error-line field="organization.name"/>
                                    </div>

                                    <div class="form-group">
                                        <label for="organization-address">Organization Address</label>
                                        <textarea class="form-control"
                                                  v-model="form.organization.address"
                                                  id="organization-address"
                                                  placeholder="Full address of the vicinity"></textarea>
                                        <error-line field="organization.address"/>
                                    </div>

                                </template>

                            </template>

                        </div>
                        <div class="card-footer d-flex align-items-center">
                            Already Registered?
                            <inertia-link class="ml-1" :href="route('login', {...global_url_params})">
                                Login Now.
                            </inertia-link>

                            <div class="actions ml-auto">
                                <state-button class="btn btn-dark"
                                              type="submit"
                                              :state="is_busy ? 'busy' : ''"
                                              :disabled="is_busy">Register</state-button>
                            </div>

                        </div>
                    </form>
                </div>
            </div>
        </div>
    </auth-layout>
</template>

<script>
import AuthLayout from "@/Layouts/AuthLayout";
import Logo from "@/Components/Common/Logo";
import API from "@/API";
import {validate} from "@/helpers/validate";
import ErrorLine from "@/Components/Common/ErrorLine";
import StateButton from "@/Components/Common/StateButton";
import Slider from '@vueform/slider';
import mixpanel from "mixpanel-browser";
import utils from "@/mixins/utils";

export default {
    name: "Register",
    components: {StateButton, ErrorLine, AuthLayout, Logo, Slider},
    mixins: [utils],
    props: ['organization'],

    data(){
        return {

            debouncedPlaceSearch: _.debounce(() => this.searchPlace(), 500),

            is_busy: false,

            search: {
                is_busy: false,
                selected: null,
                query: '',
                results: [],
            },

            form: this.$inertia.form({
                first_name: '',
                last_name: '',
                email: '',
                password: '',
                password_confirmation: '',
                referred_by: '',
                number_of_students: 10,
                has_organization: true,
                create_organization: false,
                organization: {
                    name: '',
                    address: '',
                    type: null,
                    id: null,
                }
            }),
        }
    },

    computed: {

        is_invalid(){
            return !this.is_valid;
        },

        is_valid(){
            return this.form.first_name.length
                && this.form.last_name.length
                && (this.form.email.length && validate.email( this.form.email ))
                && ( this.form.password.length && this.form.password === this.form.password_confirmation)
                && (this.form.number_of_students >= 0 )
                && (
                    this.form.has_organization
                        ? (
                              this.form.create_organization
                                  ? (this.form.organization.name.length && this.form.organization.address.length)
                                  : (this.form.organization.id && this.form.organization.type)
                        )
                        : true
                );
        },

        selected_item_id(){
            return this.search.selected;
        },

        referred_org(){
            if( ! this.organization ) return;
            return {
                id: `org-${this.organization.id}`,
                type: 'org',
                value: this.organization,
            };
        },

        registered() {
            return 'registered';
        }

    },


    watch: {
        selected_item_id(val){
            const selected = this.search.results.find(item => item.id === val);

            if( selected ){
                this.form.organization.id = selected.type === 'ac' ? selected.value.place_id : selected.value.id;
                this.form.organization.type = selected.type;
            }else{
                this.form.organization.id = null;
                this.form.organization.type = null;
            }
        }
    },


    methods: {

        async searchPlace(){
            this.clearPlaceSearch();
            if( jQuery.trim( this.search.query ).length <= 0 ) return;
            this.search.is_busy = true;

            const results = await API.organizations.search({q: this.search.query});
            if( this.referred_org ){
                const idx = results.findIndex((item) => item.id === this.referred_org.id );
                if( idx >= 0 ) results.splice(idx, 1);
                results.unshift( this.referred_org );
            }
            this.search.results = results;
            this.search.is_busy = false;
        },

        clearPlaceSearch(){
            this.search.is_busy = false;
            this.search.selected = null;
            this.search.results.length = 0;
            this.form.organization.name = '';
            this.form.organization.address = '';
            this.form.organization.type = null;
            this.form.organization.id = null;
        },

        createOrganization(create){
            this.clearPlaceSearch();
            this.search.query = '';
            this.form.create_organization = !!create;
        },

        submit(){
            this.form.post(this.route('register', {...this.global_url_params}), {
                onStart: () => this.is_busy = true,
                onFinish: () => this.form.reset('password', 'password_confirmation'),
                onSuccess: (res) => {
                    mixpanel.track('REGISTER', this.utils.flatten(res.props.user));
                    mixpanel.identify(res.props.user.id);
                },
                onError: () => this.is_busy = false,
            });
        }

    },

    mounted() {
        this.setTitle( 'Register for Design for Change USA' );

        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        if (urlParams.get('email') != '') this.form.email = urlParams.get('email');

        if( this.referred_org ){
            this.search.results = [ this.referred_org ];
            // this.search.query = this.organization.name;
            this.search.selected = this.search.results[0].id;
        }
    }

}
</script>

<style lang="scss" scoped>
.search-item{
    border-bottom: $light-borders solid 1px;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
}
.user-count{
    display: inline-block;
    color: $do;
    margin-left: .3rem;
}
</style>
